import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
export const SaveIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="download"><path id="symbol" fillRule="evenodd" clipRule="evenodd" d="M13 14.5858V2H11V14.5858L5.70712 9.29289L4.29291 10.7071L12 18.4142L19.7071 10.7071L18.2929 9.29289L13 14.5858ZM4 22H20V20H4V22Z" fill="#131416" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};